import { createSelector } from '@reduxjs/toolkit'

import { ApplicationState } from 'redux/Stores/types'
import { EconomySet } from 'types/GlobalEconomySets'
import { sortAlphabeticalAsc } from 'utils/sortHelper'

export const selectShouldFetch = createSelector(
  [
    // Input selectors:
    (state: ApplicationState) => state.EconomySetStore.fetched,
    (state: ApplicationState) => state.EconomySetStore.fetching
  ],
  (fetched, fetching): boolean => !fetched && !fetching
)

// sorted economy sets, loading
export const selectEconomySets = createSelector(
  [
    // Input selectors:
    (state: ApplicationState) => state.EconomySetStore.data,
    (state: ApplicationState) =>
      !state.EconomySetStore.fetched || state.EconomySetStore.fetching
  ],
  (data, loading): [EconomySet[], boolean] => {
    if (loading) {
      return [[], true]
    }

    return [
      Object.values(data).sort((a, b) => sortAlphabeticalAsc(a.name, b.name)),
      false
    ]
  }
)

// select economy sets keyed by id
export const selectEconomySetsData = createSelector(
  [(state: ApplicationState) => state.EconomySetStore.data],
  (data) => data
)

export const selectEconomySetsFetched = createSelector(
  [(state: ApplicationState) => state.EconomySetStore.fetched],
  (fetched) => fetched
)
